// smart contracts related configurations/constants
export const USD_DECIMALS = 18;
export const CRO_DECIMALS = 18;
export const WCRO_DECIMALS = 18;
export const BALLZ_DECIMALS = 18;
